import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/globals.css';

// Suppress the Recharts "width(-1) and height(-1) of chart should be
// greater than 0" warning. We already applied Recharts' own suggested
// remedy (minWidth={0} / minHeight={0} on every ResponsiveContainer in
// commit 5d2a76f), but the warning still fires whenever the
// ResizeObserver catches a transient 0×0 parent measurement during
// panel transitions, mobile bottom-sheet expand/collapse, or layer
// swaps. Recharts re-measures and renders correctly on the very next
// frame — the message is purely log noise that clutters the device
// console during demos. Narrow string-match so unrelated warnings
// (legitimate React/Recharts issues) still come through.
const originalWarn = console.warn.bind(console);
console.warn = (...args: unknown[]) => {
  const first = args[0];
  if (typeof first === 'string' && first.includes('width(-1) and height(-1) of chart')) {
    return;
  }
  originalWarn(...args);
};

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
